import { DISABLED_CARD_STYLE, REQUEST_STATUS } from '../Model/Models';
import { useTranslation } from 'react-i18next';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */
const RequestStatusCardApp = ({ status = [], statusToShow = [] }) => {
    const { t } = useTranslation();
    /**
     * Create a lookup object mapping status IDs to their corresponding REQUEST_STATUS details.
     */
    const statusById = Object.values(REQUEST_STATUS).reduce((acc, statusItem) => {
        acc[(statusItem.id)] = statusItem;
        return acc;
    }, {});


    /**
     * Combine statusData with REQUEST_STATUS definitions:
     * - Convert `name` (string) to integer ID
     * - Add `total` (count) from statusData
     * - Add `disabled` flag if count is zero
     */
    const requestStatus = (status || []).reduce((acc, { id, count }) => {
        if (statusById[id]) {
            acc[id] = { ...statusById[id], total: count, disabled: count === 0 };
        }
        return acc;
    }, {});
    /**
     * Filter statuses:
     */
    const idsToRender = statusToShow?.length > 0 ? statusToShow : Object.keys(statusById).map(Number);

    const filteredStatus = idsToRender
        .map((id) => {
            const baseStatus = statusById[id];
            if (!baseStatus)
                return null;

            return requestStatus[id] ?? {
            ...baseStatus,
                      total: 0,
                      disabled: true,
                      classCard: DISABLED_CARD_STYLE.classCard,
                      fontColor: DISABLED_CARD_STYLE.fontColor,
                      iconColor: DISABLED_CARD_STYLE.iconColor,
                  };
        })
        .filter(Boolean);
    return { filteredStatus, t };
};

export default RequestStatusCardApp;
